const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof rbiApp !== "undefined") return resolve();
	__webpack_require__.l("https://dev-fselect.apps.eagle.org/fs-rbi/remoteEntry.js", (event) => {
		if(typeof rbiApp !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		__webpack_error__.event = event;
		reject(__webpack_error__);
	}, "rbiApp");
}).then(() => (rbiApp));